import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function EditUserModal({ user, grupos, closeModal, onDataEdited }) {
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setSelectedGroupId(user.grupo_id || '');
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { error: linkError } = await supabase
        .from('usuarios_grupos')
        .upsert({ user_id: user.id, grupo_id: selectedGroupId }, { onConflict: 'user_id' });

      if (linkError) throw linkError;

      onDataEdited();
      closeModal();

    } catch(updateError) {
      setError(updateError.message);
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Editar Usuário</h2>
        <p className="description">Editando: {user.email}</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Associar ao Grupo</label>
            <select value={selectedGroupId} onChange={(e) => setSelectedGroupId(e.target.value)} required>
              <option value="" disabled>Selecione um grupo</option>
              {grupos.map(g => (<option key={g.id} value={g.id}>{g.nome_grupo}</option>))}
            </select>
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUserModal;